import { GraphQLID, GraphQLNonNull, GraphQLString } from 'graphql'
import {
  RouteCoverageFilterArg,
  routeCoverageFilterArgType
} from './route-coverage-filter-args'

export interface RouteQuickFilterQueryArgs {
  readonly organizationID: string
  readonly applicationID: string
  readonly filters?: RouteCoverageFilterArg
}

export const routeQuickFilterArgs = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  applicationID: {
    description: 'The unique ID for the application being queried',
    type: new GraphQLNonNull(GraphQLString)
  },
  filters: {
    description: 'A collection of filters to apply to the query',
    type: routeCoverageFilterArgType
  }
}
